/**
 * The `chainId` launch parameter, read from the URL once at module load.
 *
 * Requests fired on the first tick (auth refresh / profile / telegram login) run
 * before `useInitialiseApp` dispatches `setChainId` and before redux-persist
 * rehydrates, so the store can't supply the header yet. Capturing it here also
 * survives the router rewriting the query string later.
 */
const launchChainId = typeof window === 'undefined' ? null : new URLSearchParams(window.location.search).get('chainId');

export const getLaunchChainId = (): string | null => launchChainId;
